'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
import UIButton from '@/components/atoms/UIButtons/UIButton';
import NewsCardGrid from '@/components/news/NewsCardGrid';
export default function NewsIndexList(t0) {
  const $ = _c(13);
  const {
    items: t1,
    initialCount: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const items = t3;
  const initialCount = t2 === undefined ? 52 : t2;
  const [count, setCount] = useState(initialCount);
  let t4;
  if ($[2] !== count || $[3] !== items) {
    t4 = items.slice(0, count);
    $[2] = count;
    $[3] = items;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const displayed = t4;
  const hasMore = displayed.length < items.length;
  let t5;
  if ($[5] !== displayed) {
    t5 = <NewsCardGrid items={displayed} />;
    $[5] = displayed;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== hasMore || $[8] !== initialCount) {
    t6 = hasMore && <div className="mt-10 flex justify-center"><UIButton variant="primaryTheme" className="!rounded-full !text-base !px-6" onClick={() => setCount(current => current + initialCount)}>Load more articles</UIButton></div>;
    $[7] = hasMore;
    $[8] = initialCount;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}